import DirectionNavigatorComponent from './direction-navigator-component';

/***
 * A simple navigation option on a page that allows you to easily browse left and right between values.
 */
const directionNavigator = angular
    .module('FacilityData.Common.DirectionNavigator', [])
    .component('directionNavigator', DirectionNavigatorComponent)
    .name;

export default directionNavigator;


// WEBPACK FOOTER //
// ./app/common/direction-navigator/direction-navigator.js